'use client';

import Box from '@mui/material/Box';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import {
  H2Renderer,
  H3Renderer,
  LinkRenderer,
  LiRenderer,
  PRenderer
} from './renderers';
import { useJsScript } from './useJsScript';

type Props = {
  markdown: string;
  size?: 'small' | 'medium';
};

export const MarkdownText: React.FC<Props> = ({
  markdown,
  size = 'medium'
}) => {
  const { extracted } = useJsScript(markdown);
  return (
    <Box sx={{ wordWrap: 'break-word' }}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          ul: (props) => <ul style={{ paddingLeft: '1.2rem' }} {...props} />,
          ol: (props) => <ol style={{ paddingLeft: '1.2rem' }} {...props} />,
          a: (props) => LinkRenderer({ ...props, size }),
          li: (props) => LiRenderer({ ...props, size }),
          h1: (props) => H2Renderer({ ...props, size }),
          h2: (props) => H2Renderer({ ...props, size }),
          h3: (props) => H3Renderer({ ...props, size }),
          p: (props) => PRenderer({ ...props, size })
        }}
      >
        {extracted}
      </ReactMarkdown>
    </Box>
  );
};
